import { render } from "./ThePicturesFilter.vue?vue&type=template&id=1c8c0550"
import script from "./ThePicturesFilter.vue?vue&type=script&lang=js"
export * from "./ThePicturesFilter.vue?vue&type=script&lang=js"

import "./ThePicturesFilter.vue?vue&type=style&index=0&id=1c8c0550&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__